'use strict';
import { BaseService } from '@narrate/base-sdk';

/**
 * uses attributes api to store and retrieve the user profile
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 *
 *    const { users } = await Core.api.search.list('megz');
 *    console.log(users); // should be something like [{ username: 'megzany', name: 'Meg Zany' }]
 *
 */
class SearchService extends BaseService {

  constructor() {
    super({ configPath: 'services.search' });
  }

  list = async query => {
    return await this.requestRootResource({
      method: 'get',
      queryParams: { q: query },
      tokenType: 'none',
    });
  }
}

export default SearchService;
